import api from './api';

export default {
    init(){

    }
}


// WEBPACK FOOTER //
// src/lib/preload.js